export default __webpack_public_path__ + "flexible-payment-card.bab6ea1.jpg";